import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { ClientsService, ClientProfileDto } from 'app/services/client/ClientsService';
import { AdminService } from '../../services/admin/AdminService';
import { CoachService } from '../../services/coach/CoachService';
import { Router } from '@angular/router';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ClientProfileComponent implements OnInit {

    userInfo = {
        firstName: '',
        lastName: '',
        email: '',
        currentPassword: '',
        password1: '',
        password2: '',
        ELICertified: true
    }
    onlyOne = true;
    tabIndex = 0;

    securityQuestions: any[] = [];
    questionsLoaded = false;
    securityAnswers = {
        question1: '',
        answer1: '',
        question2: '',
        answer2: '',
    }
    passwordIsValid = false;
    isStudent = false;
    myColors = ['#8b0000', '#FF6D00', '#ffa500', '#AEEA00', '#00C853'];
    passwordIsValidLevel: number;

    constructor
    (
        public _Globals: Globals,
        private _toastr: ToastrService,
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _ClientsService: ClientsService,
        private _router: Router,
        private _CryptoJs: CryptoJs
    ) {

    }

    ngOnInit() {
        (this._Globals.getIsUserStudent() == 'h64sDyw4Tn') ? this.isStudent = true : this.isStudent = false;
        console.log('is student', this.isStudent);

        this.getCoachProfile();
        $('.sidebar-wrapper li').removeClass('active');
    }

    canEditEmailAddress(status: number): boolean {
        return status == 1 ? true : false;
    }

    getCoachProfile() {

        this._CoachService.getCoachProfile(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('getCoachProfile_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log(_data);
                this.userInfo.firstName = _data.FirstName;
                this.userInfo.lastName = _data.LastName;
                this.userInfo.email = _data.Email;
                this.userInfo.ELICertified = _data.ELICertified;
            }
        });
    }

    onResize(event: any) {
        this.getCoachProfile();
    }

    saveClient() {
        const clientProfile = new ClientProfileDto();
        clientProfile.Email = this.userInfo.email;
        clientProfile.FirstName = this.userInfo.firstName;
        clientProfile.LastName = this.userInfo.lastName;

        console.log('clientProfile', clientProfile);

        if ( this.userInfo.email == '' || this.userInfo.firstName == '' || this.userInfo.lastName == '' ) {
            this._toastr.warning('Please complete all fields', 'ELI');
            return;
        }

        const emailIsValid = this.validateEmail(this.userInfo.email);
        if (!emailIsValid) {
            return;
        }

        this._ClientsService.postUpdateClient(clientProfile).subscribe((data: any) => {
            console.log('postUpdateClient_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this._toastr.success('Profile updated successfully.', 'ELI');
                    this._Globals.setFullName(this._CryptoJs.encrypt(this.userInfo.firstName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(this.userInfo.lastName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                    this._Globals.setUserEmail(this._CryptoJs.encrypt(this.userInfo.email, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                } else {
                    this._toastr.error('We are sorry. The email address you entered is already in use by another user', 'ELI');
                }
            }
        });
    }


    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == '') {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == ' ') {
            $(`#${tagId}`).val('');
        }
    }

    validateEmail(email: string): boolean {
        console.log('email', email);

        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            return true;
        } else {
            this._toastr.warning('Please enter a valid email address', 'ELI');
            return false;
        }
    }

    tabSelect(tabIndex: number) {
        console.log(tabIndex);
        this.tabIndex = tabIndex;
    }

    removeMessage() {
        $('#errorPasswordMessage').text('');
    }

    confirmationFail() {
        if (this.userInfo.password1 == '' && this.userInfo.password2 == '') {
            $('#errorPasswordMessage').text('');
        }

        if (this.userInfo.password1 != '' && this.userInfo.password2 != '') {
            if (this.userInfo.password1 !== this.userInfo.password2) {
                $('#errorPasswordMessage').text('Confirm password does not match');
                $('.pass2').removeClass('passMatch');
                $('.pass2').addClass('passNotMatch');
            } else {
                $('#errorPasswordMessage').text('');
                $('.pass2').removeClass('passNotMatch');
                $('.pass2').addClass('passMatch');
            }
        }
    }

    updatePassword() { 
        if (this.validForm() && this.passwordIsValid) {

            if (this.passwordIsValidLevel < 3) {
                this._toastr.warning('Please enter a valid password.', 'ELI');
                return;
            }

            $('body').css('cursor', 'progress');
            this._ClientsService.postUpdatePasswordFromProfile(this._CryptoJs.encrypt(this.userInfo.currentPassword, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(this.userInfo.password1, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*'), this._Globals.getUserId()).subscribe((data: any) => {

                console.log('response_postUpdatePasswordFromProfile', data);
                $('body').css('cursor', 'default');

                switch (data.result.Result) {
                    case 1:
                        this._Globals.userEmail = this.userInfo.email;
                        this._toastr.success('Password updated successfully.', 'ELI');
                        break;
                    case -1:
                        this._toastr.error('Current password is incorrect.', 'ELI');
                        break
                    default:
                        this._toastr.error('We are sorry. An error happened while trying to update the password.', 'ELI');
                }
            });
        } else {
            this._toastr.warning('Please enter a valid password.', 'ELI');
        }
    }

    validForm() {
        if ((this.userInfo.password1 !== this.userInfo.password2) || (this.userInfo.password1 == '' && this.userInfo.password2 == '')) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');
            return false;
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
        }
        return true;
    }

    validateSecurityAnswers() {

        const answer1 = $('input[name="answer1"]').val();
        const answer2 = $('input[name="answer2"]').val();

        if (answer1 == '' || answer2 == '') {
            this._toastr.warning('Please enter a valid answer for the security questions.', 'ELI');
            return;
        }

        $('body').css('cursor', 'progress');
        const answers = [
            {
                SecurityQuestionId: this.securityAnswers.question1,
                Answer: answer1
            },
            {
                SecurityQuestionId: this.securityAnswers.question2,
                Answer: answer2
            },
        ];

        console.log(answers);

        this._ClientsService.postUpdateSecurityAnswers(this._Globals.getUserId(), answers).subscribe((data: any) => {
            console.log('response_postUpdateSecurityAnswers', data);
            $('body').css('cursor', 'default');
            if (data.result.Result == 1) {
                this._toastr.success('Successfully updated.', 'ELI');
            } else {
                this._toastr.error('We are sorry. An error happened while trying to update security answers.', 'ELI');
            }
        });
    }

    getSecurityQuestions() {
        this._AdminService.getSecurityQuestions().subscribe((data: any) => {
            console.log('getSecurityQuestions_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('getSecurityQuestions_response', _data);

                this.questionsLoaded = true;
                this.securityQuestions = _data;

                this.getUserSecurityAnswers();
            }
        });
    }

    getUserSecurityAnswers() {
        this._ClientsService.getUserSecurityAnswers(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserSecurityAnswers', data);
            if (data.result.Result == 1) {
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.securityAnswers = _data;

                this.securityAnswers.question1 = _data[0].QuestionId;
                this.securityAnswers.question2 = _data[1].QuestionId;

                this.securityAnswers.answer1 = _data[0].Answer;
                this.securityAnswers.answer2 = _data[1].Answer;

                this.disableSelected(_data[0].QuestionId, 2);
                this.disableSelected(_data[1].QuestionId, 1);
            } else {
                this._toastr.error('We are sorry.  An error happened while trying to get user security answers.', 'ELI');
            }
        });
    }

    disableSelected(selected: any, target: any) {
        console.log('Selected id', selected);

        if ($('input[name="answer1"]').val() != '' || $('input[name="answer2"]').val() != '') {
            if (target == 2) {
                this.securityAnswers.answer1 = '';
            } else {
                this.securityAnswers.answer2 = '';
            }
        }


        $(`select[name=questions${target}] option`).prop('disabled', false);

        if (selected != 0) {
            $(`select[name=questions${target}] #questions${target}_${selected}`).prop('disabled', true);
        }
    }

    passwordValid(event: any) {
        console.log(event);
        this.passwordIsValidLevel = event;
        switch (event) {
            case null:
                $('#passWordText').css('color', 'black');
                $('#passWordText').css('display', 'block');
                break

            case 0:
            case 1:
            case 2:
                $('#passWordText').css('color', 'red');
                $('#passWordText').css('display', 'block');
                break;
            case 3:
            case 4:
                $('#passWordText').css('display', 'none');
                break;
        }
    }
}
